import { apiCall, createQueryString } from "../imports"

const PREFIX = "management/sales-agents"

export default {

    gets(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`);
    },

    update(saleID,data) {
        return apiCall('patch', `${PREFIX}/${saleID}`, data);
    },

    create(data) {
        return apiCall('post', `${PREFIX}`, data);
    },

    delete(saleID) {
        return apiCall('delete', `${PREFIX}/${saleID}`);
    },
}